import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import CommentButton from '../../buttons/CommentButton';
import OrderCommissionButton from '../../buttons/OrderCommissionButton';
import CommissionStatusButton from '../../buttons/CommissionStatusButton';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import MoreButton from '../../buttons/MoreButton';
import CommissionPointsAndPrice from '../../../CommissionPointsAndPrice';
import { formatDollars } from '../../../utils/formatting';
import s from './CommissionActionBar.scss';
var CommissionActionBar = function (_a) {
    var isOwner = _a.isOwner, commission = _a.deviation.commission, deviation = _a.deviation;
    var _b = useDeviationAttributes(deviation, isOwner), hasMoreActions = _b.hasMoreActions, isCommentable = _b.isCommentable, isEditable = _b.isEditable, isDeletable = _b.isDeletable, isAuthorCommissionable = _b.isAuthorCommissionable;
    if (!commission) {
        return null;
    }
    return (React.createElement(ActionBarStrip, null,
        React.createElement(CentralColumn, { className: s['bar-elements-wrapper'] },
            React.createElement("div", { className: s['left-side'] }, isCommentable && (React.createElement("span", { className: s['icon'] },
                React.createElement(CommentButton, { deviation: deviation, isOwner: isOwner })))),
            React.createElement("div", { className: s['right-side'] },
                (isOwner || commission.isActive) && isAuthorCommissionable && (React.createElement("span", { className: s['icon'] },
                    React.createElement("div", { className: s['price'] },
                        React.createElement(CommissionPointsAndPrice, { points: commission.pointsCost, price: formatDollars(commission.dollarsCost) })))),
                !isOwner && isAuthorCommissionable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(OrderCommissionButton, { deviation: deviation }))),
                isEditable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(CommissionStatusButton, { deviation: deviation }))),
                isDeletable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(DeleteButton, { deviation: deviation }))),
                isEditable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(EditButton, { deviation: deviation }))),
                hasMoreActions && (React.createElement("span", { className: s['icon'] },
                    React.createElement(MoreButton, { deviation: deviation })))))));
};
CommissionActionBar.displayName = 'CommissionActionBar';
export default CommissionActionBar;
//# sourceMappingURL=CommissionActionBar.js.map